<template>
  <TextField
    :label="$tt('email')"
    :rules="[emailRule]"
    type="email"
    name="email"
    append-inner-icon="mdi:email-outline"
    persistent-hint
  />
</template>

<script setup lang="ts">
const { emailRule } = useValidation();
</script>